import { applyOvdToStafOptionsToData } from "open-vessel-definition/build/src/converter/core/cleanup/applyOvdToStafOptionsToData";
import { cloneObject } from "@tedivo/tedivo-pure-helpers";
import { getTranslation } from "../../../../../../../app/i18/i18tn";
import ovdJsonStore from "../../../../../../../app/stores/OVDJsonStore";
/**
 * Artificial CGs can only be offered when the file actually misses some of the
 * important ones, otherwise there is nothing to invent.
 */
export function canAddArtificialCgs() {
    const lcgVcgTcgAndPairings = ovdJsonStore.lcgVcgTcgAndPairings;
    return (!!(lcgVcgTcgAndPairings === null || lcgVcgTcgAndPairings === void 0 ? void 0 : lcgVcgTcgAndPairings.missingImportantVcgs) || !!(lcgVcgTcgAndPairings === null || lcgVcgTcgAndPairings === void 0 ? void 0 : lcgVcgTcgAndPairings.missingImportantLcgs));
}
/**
 * The 3 CGs options shown in the export dialogs. The "add artificial" one is
 * dropped when there are no missing CGs to fill in.
 */
export function createCgsOptions(withArtificialCgs) {
    return [
        {
            value: "none",
            label: getTranslation("general:exportToStaf.keepIntactCgs"),
        },
        {
            value: "remove",
            label: getTranslation("general:exportToStaf.removeCgs"),
        },
        withArtificialCgs
            ? {
                value: "addArtificial",
                label: getTranslation("general:exportToStaf.addArtificialCgs"),
            }
            : undefined,
    ].filter(Boolean);
}
/**
 * Returns the OVD to export, with the chosen CGs treatment applied.
 *
 * "none" returns the very same object; "remove" and "addArtificial" always
 * return a clone, so the store's json is never touched.
 */
export function applyCgsOptionToOvd(json, addRemoveCgs) {
    var _a, _b;
    if (addRemoveCgs === "remove") {
        // applyOvdToStafOptionsToData mutates what it receives, hence the clone.
        return applyOvdToStafOptionsToData(cloneObject(json), {
            removeCGs: true,
            removeBaysWithNonSizeSlots: false,
            removeBelowTiers24AndHigher: false,
        });
    }
    if (addRemoveCgs === "addArtificial") {
        const lcgVcgTcgAndPairings = ovdJsonStore.lcgVcgTcgAndPairings;
        if (!lcgVcgTcgAndPairings || !canAddArtificialCgs())
            return json;
        return lcgVcgTcgAndPairings.addArtificialCgsToJson(json, (_b = (_a = ovdJsonStore.currentJson) === null || _a === void 0 ? void 0 : _a.shipData.masterCGs) === null || _b === void 0 ? void 0 : _b.offsetBottomBases);
    }
    return json;
}
